import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

function Navbar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Disclosure as="nav" className="bg-white shadow">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <div className="flex-shrink-0 flex items-center">
                  <Link to="/" className="text-xl font-bold text-indigo-600">
                    Chariots of Fire
                  </Link>
                </div>
                <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                    }
                  >
                    Home
                  </NavLink>
                  
                  {currentUser && currentUser.userType === 'rider' && (
                    <>
                      <NavLink
                        to="/rider/dashboard"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        Dashboard
                      </NavLink>
                      <NavLink
                        to="/rider/available-rides"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        Available Rides
                      </NavLink>
                      <NavLink
                        to="/rider/my-bookings"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        My Bookings
                      </NavLink>
                    </>
                  )}
                  
                  {currentUser && currentUser.userType === 'driver' && (
                    <>
                      <NavLink
                        to="/driver/dashboard"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        Dashboard
                      </NavLink>
                      <NavLink
                        to="/driver/vehicles"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        My Vehicles
                      </NavLink>
                      <NavLink
                        to="/driver/rides"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        My Rides
                      </NavLink>
                      <NavLink
                        to="/driver/ride-requests"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        Ride Requests
                      </NavLink>
                      <NavLink
                        to="/driver/bookings"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        Ride Bookings
                      </NavLink>
                      <NavLink
                        to="/driver/profile"
                        className={({ isActive }) =>
                          isActive
                            ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                        }
                      >
                        Profile
                      </NavLink>
                    </>
                  )}
                  
                  {currentUser && currentUser.userType === 'admin' && (
                    <NavLink
                      to="/admin/dashboard"
                      className={({ isActive }) =>
                        isActive
                          ? 'border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                      }
                    >
                      Admin Dashboard
                    </NavLink>
                  )}
                </div>
              </div>

              <div className="hidden sm:ml-6 sm:flex sm:items-center">
                {currentUser ? (
                  <div className="flex items-center space-x-4">
                    <span className="text-sm text-gray-700">
                      {currentUser.firstName} {currentUser.lastName}
                    </span>
                    <button
                      onClick={handleLogout}
                      className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Logout
                    </button>
                  </div>
                ) : (
                  <div className="flex items-center space-x-4">
                    <Link
                      to="/login"
                      className="text-gray-500 hover:text-gray-700 px-3 py-2 text-sm font-medium"
                    >
                      Login
                    </Link>
                    <Link
                      to="/register"
                      className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Register
                    </Link>
                  </div>
                )}
              </div>

              <div className="-mr-2 flex items-center sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="pt-2 pb-3 space-y-1">
              <Disclosure.Button
                as={NavLink}
                to="/"
                className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
              >
                Home
              </Disclosure.Button>
              {currentUser && currentUser.userType === 'rider' && (
                <>
                  <Disclosure.Button
                    as={NavLink}
                    to="/rider/dashboard"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    Dashboard
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/rider/available-rides"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    Available Rides
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/rider/my-bookings"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    My Bookings
                  </Disclosure.Button>
                </>
              )}
              {currentUser && currentUser.userType === 'driver' && (
                <>
                  <Disclosure.Button
                    as={NavLink}
                    to="/driver/dashboard"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    Dashboard
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/driver/vehicles"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    My Vehicles
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/driver/rides"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    My Rides
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/driver/ride-requests"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    Ride Requests
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/driver/bookings"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    Ride Bookings
                  </Disclosure.Button>
                  <Disclosure.Button
                    as={NavLink}
                    to="/driver/profile"
                    className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                  >
                    Profile
                  </Disclosure.Button>
                </>
              )}
              {currentUser && currentUser.userType === 'admin' && (
                <Disclosure.Button
                  as={NavLink}
                  to="/admin/dashboard"
                  className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                >
                  Admin Dashboard
                </Disclosure.Button>
              )}
              {currentUser && (
                <Disclosure.Button
                  as="button"
                  onClick={handleLogout}
                  className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-red-700 hover:text-red-900 hover:bg-gray-50"
                >
                  Logout
                </Disclosure.Button>
              )}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export default Navbar;
